import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  public form: FormGroup;
  public submitted = false;
  error: string;
  public id
  loading = false;
  spinnerType = SPINNER.circle;
  constructor(private ngxService: NgxUiLoaderService, private spinner: NgxSpinnerService, public fb: FormBuilder, public authenticationService: AuthenticationService, public router: Router) {
  }
  ngOnInit(): void {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]],
    })
  }
  get f() { return this.form.controls; }
  public onSubmit(values: Object): void {
    
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value
      let password = this.form.get('password').value
      let deviceType = "web";
      let version = "1";
      let role = "Merchant";
      let obj = { email: email, password: password, deviceType: deviceType, version: version, role: role }
      this.ngxService.start();
      this.authenticationService
        .login(obj)
        .subscribe(
          data => {

            this.ngxService.stop();
            localStorage.setItem('merchant_id', data._id)
            this.id = data._id
            let user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
            console.log(user.isEmailVarified, user.isFirstUpdateDone)
            if (user.isEmailVarified == true && user.isFirstUpdateDone == true) {
              let info = { email: email, name: '' }
              localStorage.setItem('merchant_user', JSON.stringify(info));
              console.log("inside if")
              this.router.navigate(["/dashboard"]);
              Swal.fire(
                "",
                "User is logged in sucessfully.",
                "success"
              );
            } else if (user.isEmailVarified == false && user.isFirstUpdateDone == false) {
              console.log("elseif 1",user)
              let info = { email: email, name: '' }
              localStorage.setItem('merchant_user', JSON.stringify(info));
              this.router.navigate(["/user-registration"]);
              Swal.fire(
                "",
                "Please complete your registration.",
                "success"
              );
            } else if (user.isEmailVarified == false && user.isFirstUpdateDone == true) {
              console.log("elseif 2",user)
              let info = { email: email, name: '' }
              localStorage.setItem('merchant_user', JSON.stringify(info));
              this.router.navigate(["/email-verification"]);
              Swal.fire(
                "",
                "Please verify your email.",
                "success"
              );
            }
          },
          error => {
            this.ngxService.stop();
            if (error.status == 401) {
              localStorage.removeItem("merchant_currentUser1");
            } else {
              Swal.fire(
                "Error",
                error.error.message,
                "error"
              );
            }
          }
        );
    }
  }
}
